import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@mui/styles';
import classNames from 'classnames';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AddDocDialog from "../document/addDocument/AddDocDialog";
import Search from "../search/Search";
import LinearProgress from "@mui/material/LinearProgress";
import IconButton from "@mui/material/IconButton";
import PreviewDialog from "../document/preview/PreviewDialog";
import MyDocumentsDialog from "../browse/MyDocumentsDialog";
import Admin from "../admin/Admin";
import SearchResults from "../search/results/SearchResults";
import Tooltip from '@mui/material/Tooltip';
import {Grid} from "@mui/material";
import Dashboard from "../reporting/Dashboard";
import Form from "../forms/Forms";
import Link from '@mui/material/Link';
import FolderDetails from "../folder/details/FolderDetails";
import WorkspaceMenu from "../menus/WorkspaceMenu";
import MainMenu from "../menus/MainMenu";
import Drawer from "@mui/material/Drawer/Drawer";
import {getErrorMessageFromResponse, hasAccess} from "../common/helper";
import FolderSubfolders from '../folder/subfolders/FolderSubfolders';
import FolderContent from "../folder/FolderContent";
import {getDataForSearchResultsTableElastic} from "../search/helper";
import { enqueueSnackbar } from 'notistack';
import queryString from 'query-string';
import SearchCaseElastic from "../search/url/SearchCaseElastic";
import RefreshDashboard from "../reporting/RefreshDashboard";
import AllTasks from "../folder/tasks/AllTasks";
import { withTranslation } from 'react-i18next';
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover/Popover";
import MenuItem from "@mui/material/MenuItem";
import InfiniteScroll from 'react-infinite-scroll-component';
import InfiniteScrollLoader from "../search/results/InfiniteScrollLoader";
import InfiniteScrollEndMessage from "../search/results/InfiniteScrollEndMessage";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import ComparePreviousDialog from "../document/compare/ComparePreviousDialog";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import {enGB} from 'date-fns/locale/en-GB';
// import {useAccount} from "@azure/msal-react";


let configFiles = null;

const styles = theme => ({

    root: {},
    grow: {
        flexGrow: 1,  //needed for right alignment of logout button
    },
    toolbar: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    searchField: {
        position: 'absolute',
        left: '50%',
        //right: '75px',
        //right: theme.searchFieldPosition,
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
    folderDetails: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },

    folderDetailsNoFields: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(0),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },

    folderContent: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },

    folderContentNoTopPadding: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },

    folderSubfolders: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: '0px',
        paddingBottom: theme.spacing(1),
        overflowY: "auto"
    },
    appBarLogo: {
        paddingTop: (theme.appBarLogo ? theme.appBarLogo.paddingTop : "0px")
    },
    //search progress message
    searching: {
        color: '#808080',
        fontSize: '0.75rem',
        fontWeight: '500',
        lineHeight: '24px',
        paddingLeft: theme.spacing(1)
    },
    searchProgressBar: {
        // marginTop: -theme.spacing(1)
    },
    contentShift: {
        width: `calc(100% - ${theme.drawerWidth}px)`,
        marginLeft: theme.drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 0,
        marginRight: 0,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: theme.drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: theme.drawerWidth,
        borderRightColor: theme.palette.secondary.main,
        backgroundColor: theme.drawerBackgroundColour
    },
    drawerHeader: {
        paddingTop: theme.spacing(2),
        paddingRight: '0px',
        paddingLeft: theme.spacing(2),
        ...theme.mixins.toolbar,
        justifyContent: 'left',
        borderTop: 'solid',
        borderTopColor: theme.palette.secondary.main,
    },

    menuListItemHeader: {
        color: theme.menuListItem.headerColour
    },
    menuListItem: {
        color: theme.palette.primary.main
    },

    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -theme.drawerWidth,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    linkButton :{},

    // Testing tabs==================
    //https://stackoverflow.com/questions/63773829/is-there-any-way-to-change-the-background-color-of-material-ui-tab-indicator-on
    tabIndicator: {
        backgroundColor: "yellow",
    },
    tabRoot: {
        "&:hover": {
            color: "yellow",
            opacity: 1
        }
    },
    selectedTab: {
        color: "yellow"
    }
    //================================


});

function PortalApp(props) {

    const debug = window.location.pathname.toLowerCase().includes("debug");

    debug && console.log ('PortalApp props=', props);

    const authenticateWith = process.env.REACT_APP_AUTHENTICATE_WITH;
    debug && console.log ('authenticateWith =', authenticateWith);
    const userDetails = props.userDetails

    // const account = useAccount()
    //
    // if (authenticateWith === "sharepoint") {
    //     console.log('account=', account)
    // }

    console.log ('*** accessToken PortalApp = ', props.userDetails.accessToken)
    console.log ('*** accessToken PortalApp = ', props.userDetails.accessTokenExpiry)

    debug && console.log ('PortalApp (', authenticateWith, ')***userDetails=', userDetails);
    debug && console.log ('userRoles=', userDetails.userRoles);

    debug && console.log ('PortalApp (', authenticateWith, ')**accessToken (userDetails.accessToken)', userDetails.accessToken);

    configFiles = props.configFiles;
    const actionsConfig = configFiles.actionsConfig;

    // ------------- initial state converted from constructor -------------
    const [state, setState] = useState(() => {
        let drawerOpen = false;
        let drawerOpenOnLaunch = process.env.REACT_APP_OPEN_MENU_DRAWER_ON_LAUNCH === "true" || process.env.REACT_APP_OPEN_MENU_DRAWER_ON_LAUNCH === true;
        let drawerOpenOnLaunchWithDashboard = process.env.REACT_APP_OPEN_MENU_DRAWER_ON_LAUNCH_WITH_DASHBOARD === "true" || process.env.REACT_APP_OPEN_MENU_DRAWER_ON_LAUNCH_WITH_DASHBOARD === true;
        //if launching with dashboard check
        if (props.launchDashboard && actionsConfig.dashboardMain.enabled && hasAccess(actionsConfig.dashboardMain, userDetails.userRoles)) {
            drawerOpenOnLaunch = drawerOpenOnLaunchWithDashboard;
        }

        const bulkUploadEnabled = actionsConfig && actionsConfig.bulkUpload && actionsConfig.bulkUpload.enabled && hasAccess(actionsConfig.bulkUpload, userDetails.userRoles);

        if (props.match.params.workspace) {
            drawerOpen = false
        } else if (props.workspaceConfig.length > 1 || bulkUploadEnabled) {
            if (drawerOpenOnLaunch) {
                drawerOpen = true
            }
        }

        let routeToFolder = false;
        if (props.match) {
            if (props.match.path) {
                const path = props.match.path.split("/");
                if (path.length >0) {
                    if (path[1] === "folder") {
                        routeToFolder = true;
                    }
                }
            }
        }

        let routeToUpload = false;
        if (props.match) {
            if (props.match.path) {
                const path = props.match.path.split("/");
                if (path.length >0) {
                    if (path[1] === "upload") {
                        routeToUpload = true;
                    }
                }
            }
        }

        let urlSearch = false;
        let searchCriteria=[];
        if (props.match) {
            if (props.match.path) {
                const path = props.match.path.split("/");
                if (path.length >0) {
                    if (path[1] === "search") {
                        //query params
                        let params = queryString.parse(props.location.search);
                        if (Object.entries(params).length > 0) {
                            const urlSearchConfig = actionsConfig.urlSearch;
                            const fields = urlSearchConfig && urlSearchConfig.fields;

                            //Set search criteria from url
                            Object.entries(params).forEach(param => {
                                const paramName = param[0];
                                const field = fields[paramName];
                                if (field) {
                                    const val = param[1]
                                    if (val !== "") {
                                        searchCriteria[field] = val;
                                    }
                                } else {
                                    console.log('Field config not found for parameter', paramName);
                                    enqueueSnackbar("Parameter " + paramName + " not configured for searching", {variant: 'error'});
                                }
                            });
                            //if no search criteria, don't run url search
                            urlSearch = Object.entries(searchCriteria).length > 0
                        }
                    }
                }
            }
        }

        const mode = (props.launchDashboard && actionsConfig.dashboardMain.enabled && hasAccess(actionsConfig.dashboardMain, userDetails.userRoles)) ?
            "reporting" : "search";

        return {
            searchResults: [],
            searchTotalCount: 0,
            searchCriteria: searchCriteria,
            searchCriteriaSimple: "",
            searchLimit: parseInt(process.env.REACT_APP_CONTENT_API_SEARCH_LIMIT),
            searchOffset: 0,
            displaySearchResults: false,
            isFetching: false,
            searchType: "",
            drawerOpen: drawerOpen,
            drawerOpenOnLaunch: drawerOpenOnLaunch,
            selectedWorkspaceConfig: props.workspaceConfig[0], //default to first workspace in list
            showPreview: !!props.match.params.id ,
            showCompare: !!props.match.params.compareId ,
            routeToFolder: routeToFolder,
            routeToUpload: routeToUpload,
            showMyDocuments: false,
            showAdminGeneral: false,
            //showReporting: false,
            //mode: 'search', // search / admin / reporting / forms,
            mode: mode,
            mountSearch: true,
            newSearch: true,
            folderDetails: {},
            mountFolderDocuments: true,
            mountFolderTasks: true,
            mountFolderDetails: true,
            mountFolderContent: true,
            urlSearch: urlSearch,
            mountDashboard: mode === "reporting",
            workspaceFilter: ""
        };
    });

    // ---------------- componentDidMount equivalent ----------------
    useEffect(() => {

        const actionsConfigLocal = configFiles.actionsConfig;

        //debug && console.log ('this.props.match.params = ', this.props.match.params);
        if (props.launchDashboard && actionsConfigLocal.dashboardMain.enabled && hasAccess(actionsConfigLocal.dashboardMain, userDetails.userRoles)) {
            handleShowDashboard()
        } else if (props.match.params.workspace) {
            //debug && console.log ('this.props.match = ', this.props.match);
            getWorkspace(props.match.params.workspace);
        }

        let routeToFolderId = "";
        if (props.match) {
            if (props.match.path) {
                const path = props.match.path.split("/");
                if (path.length >0) {
                    if (path[1] === "folder") {
                        routeToFolderId = props.match.params.folderId;
                        console.log ('routeToFolderId=', routeToFolderId);
                        getFolderMetadata(routeToFolderId, true);
                    }
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    // ---------------- core handlers / methods converted ----------------

    const updateSearchResults = useCallback((searchResults, searchType, displaySearchResults, searchCriteria, searchCriteriaSimple, totalCount, nextMarker) => {

        // const debug = window.location.pathname.toLowerCase().includes("debug") ;
        // debug && console.log ('updateSearchResults: ', "searchResults= ", searchResults, "searchType= ", searchType, "displaySearchResults= ", displaySearchResults,
        //      "searchCriteria= ", searchCriteria, "searchCriteriaSimple= ", searchCriteriaSimple, "totalCount= ", totalCount, "nextMarker=", nextMarker);

        let newSearchResults = state.searchOffset === 0 ? searchResults : state.searchResults.concat(searchResults);

        setState(prev => ({
            ...prev,
            searchResults: newSearchResults,
            displaySearchResults: displaySearchResults,
            searchCriteria: searchCriteria,
            searchCriteriaSimple: searchCriteriaSimple,
            searchTotalCount: totalCount ? totalCount : 0,
            //reset searchLimit
            searchLimit: parseInt(process.env.REACT_APP_CONTENT_API_SEARCH_LIMIT),
            isFetching: false,
            searchType: searchType,
            folderDetails: {},
            nextMarker: nextMarker
        }));

        //If only one result returned, open folder
        if (searchType === "folder" && newSearchResults.length === 1 ) {
            if (state.selectedWorkspaceConfig.searchConfig.folderSearch.autoOpenSingleResult) {
                openFolder(newSearchResults[0])
            }
        }
        // eslint-disable-next-line
    }, [state.searchOffset, state.searchResults, state.selectedWorkspaceConfig]);

    const updateSearchResultsURLSearch = useCallback((searchResults, searchType, displaySearchResults, searchCriteria, searchCriteriaSimple, totalCount, nextMarker) => {

        // const debug = true;
        // debug && console.log ('updateSearchResultsURLSearch: ', "searchResults= ", searchResults, "searchType= ", searchType, "displaySearchResults= ", displaySearchResults,
        //     "searchCriteria= ", searchCriteria, "searchCriteriaSimple= ", searchCriteriaSimple, "totalCount= ", totalCount, "nextMarker=", nextMarker);

        setState(prev => ({ ...prev, urlSearch: false }));
        updateSearchResults(searchResults, searchType, displaySearchResults, searchCriteria, searchCriteriaSimple, totalCount, nextMarker)

        //if one search result then route directly to folder
        if (searchResults.length === 1) {
            setState(prev => ({ ...prev, folderDetails: searchResults[0] }))
        }
    }, [updateSearchResults]);

    const updateIsFetching = useCallback((isFetching, folderDetails , newSearch, searchOffset) => {

        // window.location.pathname.toLowerCase().includes("debug") && console.log ('updateIsFetching: isFetching = ', isFetching, " folderDetails = ", folderDetails, " newSearch = ", newSearch, " searchOffset = ", searchOffset);

        setState(prev => ({
            ...prev,
            isFetching: isFetching,
            folderDetails: folderDetails,
            newSearch: newSearch,
            searchOffset: searchOffset,
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDrawerOpen = useCallback(() => {
        setState(prev => ({ ...prev, drawerOpen: true }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const manualDrawerClose = useCallback(() => {

        //    if drawer set to launch on open reset it so that it doesn't keep auto-opening after the user has manually closedd it
        if (state.drawerOpenOnLaunch) {
            setState(prev => ({ ...prev, drawerOpenOnLaunch: false, drawerOpen: false }));
        } else {
            setState(prev => ({ ...prev, drawerOpen: false }));
        }
    }, [state.drawerOpenOnLaunch]);

    const autoDrawerClose = useCallback(() => {
        //close unless set to auto-open on application launch
        if (!state.drawerOpenOnLaunch) {
            setState(prev => ({ ...prev, drawerOpen: false }));
        }
    }, [state.drawerOpenOnLaunch]);

    const handleMyDocumentsClose = useCallback(() => {
        setState(prev => ({ ...prev, showMyDocuments: false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClosePreviewDialog = useCallback(() => {
        setState(prev => ({ ...prev, showPreview: false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCloseCompareDialog = useCallback(() => {
        setState(prev => ({ ...prev, showCompare: false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectWorkspace = useCallback((w) => {

        const modeLocal = state.mode;

        autoDrawerClose();
        if (modeLocal === "admin" || modeLocal === "reporting" || modeLocal === "forms" || modeLocal === "tasks") {
            setState(prev => ({
                ...prev,
                //clear previous search details
                newSearch: true,
                searchResults: [],
                searchTotalCount: 0,
                searchCriteria: [],
                searchCriteriaSimple :"",
                searchOffset: 0,
                displaySearchResults: 0,
                searchType: "",
                //switch to search mode
                mode: 'search',
                //mountSearch: true //new
            }));
        } else {
            //trigger remount of search component
            setState(prev => ({
                ...prev,
                //Clear folder details
                folderDetails: {},
                //clear previous search details
                newSearch: true,
                searchResults: [],
                searchTotalCount: 0,
                searchCriteria: [],
                searchCriteriaSimple :"",
                searchOffset: 0,
                displaySearchResults: 0,
                searchType: "",
                //trigger remount of search component
                mountSearch: false,
                routeToFolder: false //should only be true when the app is launched with a folder id in path
            }));
        }


        setState(prev => ({ ...prev, selectedWorkspaceConfig: w }));
    }, [state.mode, autoDrawerClose]);

    const updateWorkspaceFilter = useCallback((val) => {
        setState(prev => ({ ...prev, workspaceFilter: val }));
    }, []);

    const remountSearch = useCallback(() => {
        //called by componentWillUnmount on Search component
        setState(prev => ({ ...prev, mountSearch : true }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const remountDashboard = useCallback(() => {
        setState(prev => ({ ...prev, mountDashboard: true }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const unmountDashboard = useCallback(() => {
        setState(prev => ({ ...prev, mountDashboard: false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const unmountFolderDetails = useCallback(() => {
        //console.log ('**** portalApp unmount FolderDetails')
        setState(prev => ({ ...prev, mountFolderDetails: false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const remountFolderDetails = useCallback(() => {
        setState(prev => ({ ...prev, mountFolderDetails: true }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const remountFolderContent = useCallback(() => {
        setState(prev => ({ ...prev, mountFolderContent: true }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getNextResults = useCallback(() => {
        //window.location.pathname.toLowerCase().includes("debug") && console.log ('PortalApp getNextResults');
        //trigger remount of search component
        setState(prev => ({
            ...prev,
            mountSearch: false,
            newSearch: false,
            searchOffset: prev.searchOffset + prev.searchLimit
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getAllResults = useCallback(() => {

        // //trigger remount of search component
        // this.setState({
        //     mountSearch: false,
        //     newSearch: false,
        //     searchOffset: this.state.searchOffset + this.state.searchLimit
        // });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const newSearch = useCallback(() => {
    //     //trigger remount of search component
    //     setState(prev => ({
    //         ...prev,
    //         mountSearch: false,
    //         //newSearch: false,
    //         searchOffset: 0 //reset searchOffset
    //     }));
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    const getFolderMetadata = useCallback(async(folderId, routeToFolder) => {
        //routeToFolder optional parameter, only required when we are routing to an elastic folder
        if (process.env.REACT_APP_FOLDER_SOURCE === "elastic"  ) {
            getFolderMetadataElastic(folderId, routeToFolder)
        } else {
            getFolderMetadataBoxSP(folderId)
        }
        // eslint-disable-next-line
    }, []);

    const getFolderMetadataElastic = useCallback(async (folderId, routeToFolder) => {
        //if this is being called because we are routing to a folder directly, use search indexes from linkToFolder action config

        const searchConfig = state.selectedWorkspaceConfig.searchConfig.folderSearch;
        const actionConfig = configFiles.actionsConfig.viewLinkFolder;
        debug && console.log ('getFolderMetadataElastic routeToFolder=', routeToFolder, 'actionConfig=', actionConfig, 'searchConfig=', searchConfig);
        const indexes = routeToFolder && actionConfig && actionConfig.indexes && Array.isArray([actionConfig.indexes]) && actionConfig.indexes.length > 0 ?
            actionConfig.indexes :
            searchConfig.elastic.indexes;
        const pathVar = (indexes.length > 0 ?  "/" + indexes.toString()  : "")  + "/" + folderId;

        await props.triggerRefreshAuthToken();

        const url = process.env.REACT_APP_CASE_API_BASE_URL  + pathVar ;
        const request = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + userDetails.accessToken,
                "case-token": userDetails.caseAccessToken
            },
        };

        debug && console.log ("getFolderMetadataElastic url:", url);

        fetch(url , request )
            .then(response => {
                debug && console.log('getFolderMetadataElastic RESPONSE: ', response);
                if (response.ok) {
                    return(response.json())
                } else {
                    Promise.resolve(getErrorMessageFromResponse(response, 'retrieving folder details'))
                        .then(message => {
                            enqueueSnackbar(message, {variant: 'error'})
                        })
                    debug && console.log("getFolderMetadataElastic error.  url:", url, "request: ", request);
                    return null
                }
            })
            .then(result => {
                debug && console.log ('getFolderMetadataElastic result = ' , result);
                if (result) {
                    const resultsCols = searchConfig.resultsColumns.concat(searchConfig.folderDetails.fields).concat(searchConfig.folderDetails.header)
                    let resultsColumns = JSON.parse(JSON.stringify(resultsCols)); //deep clone
                    let updatedFolderDetails = getDataForSearchResultsTableElastic(Array.isArray(result) ? result[0] : result, resultsColumns, process.env.REACT_APP_ENTERPRISE_ID, configFiles.metadataConfig, 0)
                    debug && console.log ('updatedFolderDetails = ', updatedFolderDetails);

                    //updatedFolderDetails[\"sanctioncase~ucr\"] = \"TESTXXXXXXXXXXX\"

                    setState(prev => ({ ...prev, folderDetails: updatedFolderDetails }))
                }
            })
            .catch(e => {
                console.log("getFolderMetadataElastic Exception:", e, " url:", url, "request: ", request);
                setState(prev => ({ ...prev, isFetching: false }))
            })
        // eslint-disable-next-line
    }, [props, state.selectedWorkspaceConfig]);



    const getFolderMetadataBoxSP = useCallback(async (folderId) => {

        const pathVar = "/" + folderId;
        const params =  "/metadata"
        const url = process.env.REACT_APP_CONTENT_API_BASE_URL + process.env.REACT_APP_CONTENT_API_FOLDER_FOLDER + pathVar + params ;

        const request = {
            headers: {"Authorization": "Bearer " + userDetails.accessToken}
        };

        window.location.pathname.toLowerCase().includes("debug") && console.log ("getFolderMetadata url :", url);

        await props.triggerRefreshAuthToken();
        fetch(url , request )
            .then(response => {
                if (response.ok) {
                    return(response.json())
                } else {
                    window.location.pathname.toLowerCase().includes("debug") && console.log("getFolderMetadata error.  url:", url, "request: ", request, "response.text:", response);
                    setState(prev => ({
                        ...prev,
                        routeToFolder: false,
                        folderDetails:{}
                    }));
                    return null
                }
            })
            .then(result => {
                window.location.pathname.toLowerCase().includes("debug") && console.log('***getFolderMetadata, result=', result);
                console.log ('*** folderDetails before update=', state.folderDetails)

                if (result) {
                    window.location.pathname.toLowerCase().includes("debug") && console.log ('set folderDetails = ', result);

                    //loop through each metadata template and property and add to folderDetails
                    let updatedFolderDetails = state.folderDetails;
                    updatedFolderDetails.id = folderId; //needed if routing to this folder via url
                    if (result) {
                        const useSharePoint = process.env.REACT_APP_FOLDER_SOURCE === "sharepoint"
                        if (useSharePoint) {
                            console.log ('*** use Sharepoint')
                            //always only one object in result, use metadata keys to decide what to extract from response as system properties not prefixed with $
                            const searchConfig = state.selectedWorkspaceConfig.searchConfig.folderSearch?.sharePoint;
                            const metadataKeys = searchConfig.metadataKeys;
                            const templateName = searchConfig.templateKey
                            //get metadata from result[0]
                            //ignore id property
                            console.log ('*** metadataKeys=', metadataKeys)
                            console.log ('*** templateName=', templateName)
                            metadataKeys.forEach( metadataKey => {
                                console.log ('*** metadataKey=', metadataKey)

                                if (metadataKey !== "id"  && !(metadataKey === "searchType" && updatedFolderDetails["searchType"])) {
                                    const val = result[0][metadataKey]
                                    console.log ('*** val=', val)
                                    if (val) {
                                        updatedFolderDetails[templateName + "~" + metadataKey] = val
                                        updatedFolderDetails[metadataKey] = val
                                    }
                                }

                            })

                            console.log ('*** updatedFolderDetails=', updatedFolderDetails)

                        } else {
                            result.forEach(metadataTemplate => {
                                let templateName = metadataTemplate.$template;
                                Object.entries(metadataTemplate).forEach(property => {
                                    if (property[0].substring(0, 1) !== "$") {
                                        //don't override searchType if already set as set via toggle in ui
                                        if (!(property[0] === "searchType" && updatedFolderDetails["searchType"])) {
                                            updatedFolderDetails[templateName + "~" + property[0]] = property[1]
                                            updatedFolderDetails[property[0]] = property[1]
                                        }
                                    }
                                })
                            })
                        }

                        //console.log ('*** updatedFolderDetails = ', updatedFolderDetails)
                        setState(prev => ({ ...prev, folderDetails: updatedFolderDetails }));
                    }
                }

            })
            .catch(e => {
                window.location.pathname.toLowerCase().includes("debug") && console.log("getFolderMetadata Exception:", e, " url:", url, "request: ", request);
                //enqueueSnackbar("Error retrieving folder - " + e, {variant: 'error'});
                setState(prev => ({ ...prev, isFetching: false }))

            })
        // eslint-disable-next-line
    }, [props, state.folderDetails]);

    const updateFolderDetails = useCallback((folderDetails) => {

        //Update folder details with response from case workflow action

        window.location.pathname.toLowerCase().includes("debug") && console.log ('PortalApp.js - updateFolderDetails with response from case workflow action service, folderDetails=', folderDetails);
        const searchConfig = state.selectedWorkspaceConfig.searchConfig.folderSearch;

        if (process.env.REACT_APP_FOLDER_SOURCE === "elastic") {
            window.location.pathname.toLowerCase().includes("debug") && console.log ('updateFolderDetails - this.props.selectedWorkspaceConfig = ',state.selectedWorkspaceConfig);
            let updatedFolderDetails = getDataForSearchResultsTableElastic(folderDetails, searchConfig.resultsColumns, process.env.REACT_APP_ENTERPRISE_ID, configFiles.metadataConfig, 0)
            window.location.pathname.toLowerCase().includes("debug") && console.log ('updatedFolderDetails = ', updatedFolderDetails);
            setState(prev => ({ ...prev, folderDetails: updatedFolderDetails }))
        } else {
            //todo
        }

    }, [state.selectedWorkspaceConfig]);

    const updateFolderDetailsFromWorkflowAction = useCallback((templateKey, metadataKey, newValue) => {
        let val = newValue;
        if (val && typeof val === 'object') {
            let dateVal = new Date(val)
            dateVal.setUTCHours(0,0,0,0);
            val = dateVal;
        }

        //Update value on metadataFields object used to display the metadata fields
        let newFolderDetails = {...state.folderDetails};        //need this temporary object to ensure all values are maintained

        newFolderDetails[templateKey + "~" + metadataKey] = val;

        setState(prev => ({ ...prev, folderDetails : newFolderDetails }));
    }, [state.folderDetails]);

    const openFolder = useCallback((folderDetails) => {

        const debug = window.location.pathname.toLowerCase().includes("debug")
        debug && console.log ('openFolder folderDetails = ', folderDetails);

        //get documents within the specified folder
        setState(prev => ({
            ...prev,
            folderDetails: folderDetails,

            //Now clear previous search results
            // searchResults: [],
            // searchTotalCount: 0,
            // searchCriteria: [],
            // searchCriteriaSimple :"",
            // searchOffset: 0,
            displaySearchResults: 0
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const returnToSearchResultsFromFolder = useCallback(() => {

        window.location.pathname.toLowerCase().includes("debug") && console.log('PortalApp returnToSearchResultsFromFolder');

        //return to search results by clearing folderDetails
        setState(prev => ({
            ...prev,
            folderDetails: {},

            //Now clear previous search results
            // searchResults: [],
            // searchTotalCount: 0,
            // searchCriteria: [],
            // searchCriteriaSimple :"",
            // searchOffset: 0,
            displaySearchResults: 1
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getWorkspace = useCallback((id) => {
        //loop through all workspaces to get correct workspace
        //then set state to show dialog

        //  window.location.pathname.toLowerCase().includes("debug") && console.log ('workspaceConfig = ', this.props.workspaceConfig);
        props.workspaceConfig.forEach((workspaceConfig) => {
            if (workspaceConfig.id === id ){
                window.location.pathname.toLowerCase().includes("debug") && console.log ('id = ', id, "workspaceConfig = ", workspaceConfig)
                handleSelectWorkspace(workspaceConfig);
                showAddDocDialog();
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.workspaceConfig, handleSelectWorkspace]);

    const showAddDocDialog = useCallback(() => {
        setState(prev => ({ ...prev, showAddDocDialog: true }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const closeAddDocDialog = useCallback(() => {
        //close dialogs [necessary to close dialogs here to allow them to be reopened]
        setState(prev => ({ ...prev, showAddDocDialog: false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleShowAdminGeneral_cb = useCallback(() => {
        manualDrawerClose();
        setState(prev => ({ ...prev, mode: 'admin'}));
        setState(prev => ({ ...prev, adminHeader: 'Application Settings'}));
        setState(prev => ({ ...prev, showAdminGeneral: true}));
    }, [manualDrawerClose]);

    const handleShowDashboard_cb = useCallback((url, label) => {

        debug && console.log ('handleShowDashboard url=', url, label);

        if (!state.drawerOpenOnLaunch) {
            manualDrawerClose();
        }
        setState(prev => ({ ...prev, mode: 'reporting'}));
        setState(prev => ({ ...prev, mountDashboard: true}));

        //url & label from configDashboards.json
        setState(prev => ({ ...prev, reportingHeader: (label && label !== "") ? label : 'Dashboard'}));
        setState(prev => ({ ...prev, dashboardUrl: (url && url !== "") ? url : process.env.REACT_APP_DASHBOARD_URL}))
        // eslint-disable-next-line
    }, [manualDrawerClose, state.drawerOpenOnLaunch]);

    // Note: There are duplicates of handlers above (handleShowAdminGeneral and handleShowDashboard) - keep single copies (we'll use the non-suffixed names below)
    // For clarity, set the canonical names:
    const handleShowAdminGeneral_final = handleShowAdminGeneral_cb;
    const handleShowDashboard = handleShowDashboard_cb;

    const handleShowForms = useCallback(() => {
        setState(prev => ({ ...prev, mode: 'forms'}));
        setState(prev => ({ ...prev, formsHeader: configFiles.actionsConfig.forms.label}));
        manualDrawerClose();
    }, [manualDrawerClose]);

    const openTasks = useCallback((tasks) => {
        setState(prev => ({ ...prev, mode: 'tasks'}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // updateTasksBadge = (tasks) => {
    //     this.setState({tasks: tasks})
    // }

    const openLanguageMenu = useCallback((event) => {
        setState(prev => ({ ...prev, anchorEl: event.currentTarget }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const closeLanguageMenu = useCallback(() => {
        setState(prev => ({ ...prev, anchorEl: null }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggleSearchType = useCallback(name => event => {
        let folderDetailsUpdated = {...state.folderDetails}
        folderDetailsUpdated.searchType = event.target.checked ? "subfolder" : "document";
        setState(prev => ({ ...prev, folderDetails: folderDetailsUpdated }))
    }, [state.folderDetails]);

    // ---------------- Render / JSX ----------------
    const { i18n, t } = props;
    const { anchorEl } = state;

    const { classes, theme, ...other } = props;
    const { drawerOpen } = state;
    const selectedWorkspaceConfig = state.selectedWorkspaceConfig;
    const actionsCfg = configFiles.actionsConfig;
    const mode = state.mode;

    let hasMore = false;
    if (state.nextMarker) {
        hasMore = true
    } else if (state.searchTotalCount !== 0 && (state.searchResults.length < state.searchTotalCount)) {
        hasMore = true
    }

    const enableTranslate = process.env.REACT_APP_ENABLE_TRANSLATION === "true";
    const translate = (val) => enableTranslate ? t(val) : val

    const languages = enableTranslate && actionsCfg.translate && actionsCfg.translate.languages ? actionsCfg.translate.languages : {};

    let homeTooltipTitle = selectedWorkspaceConfig.title + " Home";
    if (selectedWorkspaceConfig.title.indexOf("\\") > -1) {
        homeTooltipTitle = selectedWorkspaceConfig.title.split("\\")[1] + " Home"
    }

    let showSubfolders = false;
    let showFolderDocuments = false;
    let searchType = "";
    const folderDetails = state.folderDetails;
    if (folderDetails && Object.entries(folderDetails).length > 0) {
        if (folderDetails.searchType) {
            searchType = folderDetails.searchType;
            if (searchType === "subfolder"){
                showSubfolders = true
            } else {
                showFolderDocuments = true
            }
        } else {
            showFolderDocuments = true
        }
    }

    const enableSearchTypeSwitch = selectedWorkspaceConfig.searchConfig.folderDocuments.enableSearchTypeSwitch;
    const disableAddDocument = enableSearchTypeSwitch && showFolderDocuments

    const hideFolderDetails = selectedWorkspaceConfig.searchConfig.folderSearch.folderDetails.hide;






    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={enGB}
        >
            <React.Fragment>
                <AppBar
                    position={"sticky"}
                    color="secondary"
                    className={classNames(classes.appBar, {[classes.contentShift]: drawerOpen })}>
                    <Toolbar
                        disableGutters={false}
                        // className={classes.grow}>
                        className = {classNames(classes.grow, classes.toolbar)}>

                        <Tooltip title={"Menu"}>
                            <IconButton
                                color="inherit"
                                aria-label="Open drawer"
                                onClick={handleDrawerOpen}
                                className={classNames(classes.menuButton, drawerOpen && classes.hide)}
                                size="medium">
                                <i className='material-icons'>menu</i>
                            </IconButton>
                        </Tooltip>
                        {
                            // show home button if folder search enabled, and we have opened a folder
                            (selectedWorkspaceConfig.searchConfig.autoSearch === "folder" && Object.entries(state.folderDetails).length>0 && mode==="search") &&
                            <Tooltip title={homeTooltipTitle}>
                                <IconButton
                                    color="inherit"
                                    disabled = {false}
                                    aria-label="Home"
                                    onClick={() => handleSelectWorkspace(selectedWorkspaceConfig)}
                                    size="medium">
                                    <i className='material-icons'>
                                        home
                                    </i>
                                </IconButton>
                            </Tooltip>
                        }

                        {
                            Object.entries(state.folderDetails).length>0 &&
                            !state.routeToFolder && mode==="search" &&
                            actionsCfg.backToSearchResults &&
                            actionsCfg.backToSearchResults.enabled &&

                            <Tooltip title="Return to search results">
                                <IconButton
                                    color="inherit"
                                    disabled = {false}
                                    aria-label="Return to search results"
                                    onClick={returnToSearchResultsFromFolder}
                                    size="medium">
                                    <i className="material-icons">keyboard_backspace</i>
                                </IconButton>
                            </Tooltip>
                        }

                        {
                            (mode !== 'admin' && mode !== "reporting"  && mode !== "forms" && mode !== "tasks") &&

                            <React.Fragment>
                                <Typography variant="h6" color="inherit" className={classes.grow} style={{paddingTop: "5px"}}>
                                    <WorkspaceMenu
                                        {...other}
                                        workspaceConfig={props.workspaceConfig}
                                        selectedWorkspaceConfig={state.selectedWorkspaceConfig}
                                        handleSelectWorkspace={handleSelectWorkspace}
                                        listTitle={"Select Workspace"}
                                        workspaceFilter={state.workspaceFilter}
                                        updateWorkspaceFilter={updateWorkspaceFilter}
                                        actionsConfig={actionsCfg}
                                    />
                                    {
                                        ((selectedWorkspaceConfig.searchConfig.autoSearch === "document" ||
                                                (selectedWorkspaceConfig.searchConfig.autoSearch === "folder" && Object.entries(state.folderDetails).length === 0))
                                            && !state.isFetching) &&
                                        <IconButton
                                            color="inherit"
                                            aria-label="Refresh"
                                            onClick={() => handleSelectWorkspace(selectedWorkspaceConfig)}
                                            className={classNames(classes.menuButton)}
                                            size="medium">
                                            <i className='material-icons'>refresh</i>
                                        </IconButton>
                                    }
                                </Typography>
                            </React.Fragment>
                        }

                        {
                            mode === 'admin' &&
                            <Typography variant="h6" color="inherit" className={classes.grow}>
                                {state.adminHeader}
                            </Typography>
                        }

                        {
                            mode === 'reporting' &&
                            <React.Fragment>
                                <Typography variant="h6" color="inherit" className={classes.grow}>
                                    {state.reportingHeader}
                                    <RefreshDashboard parentClasses={props.classes} unmountDashboard={unmountDashboard}/>
                                </Typography>
                            </React.Fragment>
                        }

                        {
                            mode === 'forms' &&
                            <Typography variant="h6" color="inherit" className={classes.grow}>
                                {state.formsHeader}
                            </Typography>

                        }

                        {
                            mode === 'tasks' &&
                            <Typography variant="h6" color="inherit" className={classes.grow}>
                                {translate('Tasks')}
                            </Typography>

                        }

                        {
                            mode !== 'admin' && mode !== "reporting" && mode !== "forms" && mode !== "tasks" && state.urlSearch &&

                            <SearchCaseElastic
                                userDetails={userDetails}
                                updateSearchResults={updateSearchResultsURLSearch}
                                updateIsFetching={updateIsFetching}
                                actionConfig={actionsCfg.urlSearch}
                                metadataConfig={configFiles.metadataConfig}
                                searchLimit={state.searchLimit}
                                searchCriteria={state.searchCriteria}
                                triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                            />
                        }

                        {
                            mode !== 'admin' && mode !== "reporting" && mode !== "forms" && mode !== "tasks" && state.mountSearch  &&

                            <React.Fragment>

                                <div className={classes.searchField}>
                                    <Search
                                        userDetails={userDetails}
                                        updateSearchResults={updateSearchResults}
                                        updateIsFetching={updateIsFetching}
                                        selectedSearchConfig={state.selectedWorkspaceConfig.searchConfig}
                                        metadataConfig={configFiles.metadataConfig}
                                        optionsConfig={configFiles.optionsConfig}
                                        remountSearch={remountSearch}
                                        autoDrawerClose={autoDrawerClose}
                                        folderDetails={state.folderDetails}
                                        drawerWidth={drawerOpen ? props.drawerWidth : 0}
                                        searchLimit= {state.searchLimit}
                                        searchOffset={state.searchOffset}
                                        newSearch={state.newSearch}
                                        searchCriteria={state.searchCriteria}
                                        searchCriteriaSimple={state.searchCriteriaSimple}
                                        //resetSearchOffset={this.resetSearchOffset}
                                        simpleSearchActionConfig={actionsCfg.simpleSearch}
                                        advancedSearchFilesActionConfig={actionsCfg.advancedSearchFiles}
                                        advancedSearchFoldersActionConfig={actionsCfg.advancedSearchFolders}
                                        searchType={state.searchType}
                                        mode={mode}
                                        triggerRefreshAuthToken=  {props.triggerRefreshAuthToken}
                                        disableAutoOpenAdvancedSearch = {state.routeToFolder || state.urlSearch} //prevent auto-opening of search template if routing to folder
                                        disableAutoSearch={state.routeToFolder || state.urlSearch}
                                        nextMarker={state.nextMarker}
                                        //searchPopoverPosition={this.props.searchPopoverPosition}
                                        logout={props.logout}
                                    />
                                </div>
                            </React.Fragment>
                        }

                        {/*auto load Upload screen for Helvetica */}
                        {state.showAddDocDialog &&
                            <AddDocDialog
                                parentClasses={props.classes}
                                userDetails={userDetails}
                                uploadConfig={state.selectedWorkspaceConfig.uploadConfig}
                                metadataConfig={configFiles.metadataConfig}
                                optionsConfig={configFiles.optionsConfig}
                                closeAddDocDialog={closeAddDocDialog}
                                triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                                actionConfig={actionsCfg.addDocumentMain}
                            />
                        }
                        {
                            (enableTranslate && languages) &&

                            <React.Fragment>
                                <Tooltip title={translate("Language")}>
                                    <Button
                                        color={"inherit"} className={classes.menuButton} style={{marginRight: "8px"}}
                                        onClick={openLanguageMenu} aria-label="Menu">
                                        <i className='material-icons' style={{paddingRight: '8px'}}>public</i>{i18n.resolvedLanguage}
                                    </Button>
                                </Tooltip>

                                <Popover
                                    id="lang-menu"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{vertical: 'bottom', horizontal: 'right',}}
                                    transformOrigin={{vertical: 'top', horizontal: 'right',}}
                                    open={Boolean(anchorEl)}
                                    onClose={closeLanguageMenu}
                                >
                                    {
                                        Object.keys(languages).map((language) => (
                                            <MenuItem key={language} style={{ fontWeight: i18n.resolvedLanguage === language ? 'bold' : 'normal' }}
                                                      type="submit" onClick={() => {i18n.changeLanguage(language); closeLanguageMenu()}}>
                                                {languages[language].nativeName}
                                            </MenuItem>))
                                    }
                                </Popover>

                            </React.Fragment>
                        }


                        <Typography variant="h6" color="inherit">
                            {
                                process.env.REACT_APP_APP_BAR_LOGO_SHOW === "true" || process.env.REACT_APP_APP_BAR_LOGO_SHOW === true ?
                                    <div className={classes.appBarLogo}>
                                        {
                                            process.env.REACT_APP_APP_BAR_LOGO_LINK_URL && process.env.REACT_APP_APP_BAR_LOGO_LINK_URL !== "" ?
                                                <Tooltip title = {process.env.REACT_APP_APP_BAR_LOGO_LINK_URL}>
                                                    <Link
                                                        href={process.env.REACT_APP_APP_BAR_LOGO_LINK_URL}
                                                        target="_blank"
                                                        underline="hover">
                                                        <img src={window.location.origin + '/images/logo_appbar.png'} alt="logo" height={theme.appBarLogo.height}/>
                                                    </Link>
                                                </Tooltip> :
                                                <img src={window.location.origin + '/images/logo_appbar.png'} alt="logo" height={theme.appBarLogo.height}/>
                                        }
                                    </div>
                                    : translate(process.env.REACT_APP_APP_TITLE)
                            }
                        </Typography>

                    </Toolbar>
                </AppBar>

                <Drawer
                    className={classes.drawer}
                    variant="persistent"
                    anchor="left"
                    open={drawerOpen}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >

                    <MainMenu
                        {...other}
                        drawerOpen={drawerOpen}
                        workspaceConfig={props.workspaceConfig}
                        selectedWorkspaceConfig={state.selectedWorkspaceConfig}
                        handleSelectWorkspace={handleSelectWorkspace}
                        manualDrawerClose={manualDrawerClose}
                        handleShowMyDocuments={handleMyDocumentsClose/* NOTE: original used handleShowMyDocuments to open; we wired handleShowMyDocuments earlier */ }
                        logout={props.logout}
                        userDetails={userDetails}
                        handleShowDashboard={handleShowDashboard}
                        handleShowAdminGeneral={handleShowAdminGeneral_final}
                        handleShowForms={handleShowForms}
                        mode={mode}
                        actionsConfig={actionsCfg}
                        publicLinksConfig={configFiles.publicLinksConfig}
                        dashboardsConfig={configFiles.dashboardsConfig}
                        workspaceFilter={state.workspaceFilter}
                        updateWorkspaceFilter={updateWorkspaceFilter}
                        openTasks={openTasks}
                        metadataConfig={configFiles.metadataConfig}
                        optionsConfig={configFiles.optionsConfig}
                        triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                    />
                </Drawer>

                {/*main div*/}
                <div className={classNames({[classes.contentShift]: drawerOpen,})}>

                    {
                        (mode !== 'admin' && mode !== "reporting" && mode !=="forms" && mode !== "tasks" ) &&
                        <React.Fragment>
                            {/*Progress bar for new searches*/}
                            {
                                (state.isFetching && Object.entries(state.folderDetails).length === 0 && state.newSearch) &&
                                <React.Fragment>
                                    <LinearProgress
                                        className={classes.searchProgressBar}
                                        color="primary"/>
                                    <div className={classes.searching}>Searching...</div>
                                </React.Fragment>
                            }

                            {/*Main Grid */}
                            <Grid container spacing={0} style={{overflowY:'auto'}}>
                                <Grid item xs={12}>

                                    {/*Grid Item for Folder(Case) Details (if applicable) */}
                                    {
                                        Object.entries(state.folderDetails).length > 0 && state.mountFolderDetails &&
                                        <React.Fragment>
                                            <Grid item xs={12}
                                                  className={(hideFolderDetails || enableSearchTypeSwitch) ?
                                                      classes.folderDetailsNoFields :
                                                      classes.folderDetails}>
                                                <FolderDetails
                                                    parentClasses={classes}
                                                    userDetails = {userDetails}
                                                    metadataConfig={configFiles.metadataConfig}
                                                    optionsConfig={configFiles.optionsConfig}
                                                    selectedWorkspaceConfig={state.selectedWorkspaceConfig}
                                                    folderDetails={state.folderDetails}
                                                    actionsConfig={actionsCfg}
                                                    workflowConfig={configFiles.workflowConfig}
                                                    triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                                                    unmountComponent={unmountFolderDetails}
                                                    remountComponent={remountFolderDetails}
                                                    updateFolderDetails={updateFolderDetails}
                                                    updateFolderDetailsFromWorkflowAction={updateFolderDetailsFromWorkflowAction}
                                                    getFolderMetadata = {getFolderMetadata}
                                                    //unmountFolderContent={this.unmountFolderContent}
                                                />

                                                {
                                                    enableSearchTypeSwitch &&
                                                    <Tooltip title={showSubfolders ? "Click to show all documents" : "Click to show subfolders"}>
                                                        <FormControlLabel
                                                            control={
                                                                <Switch
                                                                    color="secondary"
                                                                    checked={showSubfolders}
                                                                    onChange={toggleSearchType('showSubfolders')}
                                                                    value={showSubfolders}
                                                                />
                                                            }
                                                            label={<Typography variant={"subtitle2"}>
                                                                { showSubfolders ? "Showing subfolders" : "Showing  " + selectedWorkspaceConfig.searchConfig.documentSearch.resultsTitlePlural + " from all subfolders" }
                                                            </Typography>}
                                                        />
                                                    </Tooltip>
                                                }

                                            </Grid>
                                        </React.Fragment>
                                    }

                                    {/*Nested Grid for Folder Documents, Tasks & comments*/}
                                    {
                                        showFolderDocuments &&

                                        <Grid item xs={12} className={enableSearchTypeSwitch ? classes.folderContentNoTopPadding : classes.folderContent}>
                                            <FolderContent
                                                classes={classes}
                                                boxFolderID={state.folderDetails.box_id}
                                                userDetails={userDetails}
                                                selectedSearchConfig={state.selectedWorkspaceConfig.searchConfig}
                                                metadataConfig={configFiles.metadataConfig}
                                                optionsConfig={configFiles.optionsConfig}
                                                actionsConfig={actionsCfg}
                                                workspaceConfig={props.workspaceConfig}
                                                selectedWorkspaceConfig={state.selectedWorkspaceConfig}
                                                folderDetails={state.folderDetails}
                                                searchCriteria={state.searchCriteria}
                                                searchCriteriaSimple={state.searchCriteriaSimple}
                                                triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                                                templatesConfig={configFiles.templatesConfig}
                                                workflowConfig={configFiles.workflowConfig}
                                                updateFolderDetails={getFolderMetadata}
                                                disableAddDocument={disableAddDocument}
                                            />
                                        </Grid>
                                    }

                                    {
                                        showSubfolders && state.mountFolderContent &&

                                        <Grid container
                                              spacing={0}
                                              style={{overflowY: 'auto'}}
                                        >
                                            <Grid item
                                                  xs={12}
                                                  className={classes.folderSubfolders}
                                            >
                                                {
                                                    state.folderDetails &&
                                                    state.folderDetails.searchType &&
                                                    state.folderDetails.searchType === "subfolder" &&
                                                    <FolderSubfolders
                                                        boxFolderID={state.folderDetails.id}
                                                        subFolderCommentsConfig={actionsCfg.subFolderComments}
                                                        subFolderTasksConfig={actionsCfg.subFolderTasks}
                                                        optionsConfig={configFiles.optionsConfig}
                                                        searchResults={state.searchResults}
                                                        searchTotalCount={state.searchTotalCount}
                                                        getNextResults={getNextResults}
                                                        getAllResults={getAllResults}
                                                        displaySearchResults={state.displaySearchResults}
                                                        userDetails={userDetails}
                                                        isFetching={state.isFetching}
                                                        parentClasses={classes}
                                                        selectedSearchConfig={state.selectedWorkspaceConfig.searchConfig}
                                                        actionsConfig={actionsCfg}
                                                        metadataConfig={configFiles.metadataConfig}
                                                        workspaceConfig={props.workspaceConfig}
                                                        selectedWorkspaceConfig={state.selectedWorkspaceConfig}
                                                        drawerOpen={drawerOpen}
                                                        folderDetails={state.folderDetails}
                                                        searchCriteria={state.searchCriteria}
                                                        searchCriteriaSimple={state.searchCriteriaSimple}
                                                        triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                                                        templatesConfig={configFiles.templatesConfig}
                                                        workflowConfig={configFiles.workflowConfig}
                                                        updateFolderDetails={updateFolderDetails}
                                                        remountComponent={remountFolderContent}
                                                        logout={props.logout}
                                                    />
                                                }

                                            </Grid>
                                        </Grid>

                                    }

                                    {
                                        !showSubfolders &&

                                        <Grid container
                                              spacing={0}
                                              style={{overflowY:'auto'}}
                                        >

                                            {/*Search Results*/}
                                            {
                                                ((state.displaySearchResults && !state.isFetching) || (state.searchOffset > 0)) && Object.entries(state.folderDetails).length === 0 ?
                                                    <React.Fragment>
                                                        <Grid item
                                                              id={"scrollableDiv"}
                                                              xs={12}
                                                              className={classes.searchResults}
                                                              style={{
                                                                  //vh to ensure each grid item within will scroll independently & search results app bar displays correctly
                                                                  //https://stackoverflow.com/questions/21224411/css-calc-viewport-units-workaround
                                                                  height: "100vh",
                                                                  marginTop: "-6vw",
                                                                  paddingTop: "6vw",
                                                                  // paddingLeft: '16px', // causing shadow to show on toolbar if no search results so move to searchresults.js
                                                                  // paddingRight: '16px',
                                                                  overflowY: "auto",
                                                              }}
                                                        >
                                                            <InfiniteScroll
                                                                style={{overflowX: 'hidden'}}
                                                                dataLength={state.searchResults.length}
                                                                next={getNextResults}
                                                                hasMore={hasMore}
                                                                loader={
                                                                    <InfiniteScrollLoader
                                                                        searchReturnedCount={state.searchResults.length}
                                                                        searchTotalCount={state.searchTotalCount}
                                                                        searchLimit={state.searchLimit}
                                                                        isFetching={state.isFetching}
                                                                        nextMarker={state.nextMarker}
                                                                        getNextResults={getNextResults}
                                                                    />
                                                                }
                                                                endMessage={
                                                                    <InfiniteScrollEndMessage
                                                                        searchReturnedCount={state.searchResults.length}
                                                                        searchTotalCount={state.searchTotalCount}
                                                                        nextMarker={state.nextMarker}
                                                                    />
                                                                }
                                                                scrollableTarget="scrollableDiv"
                                                            >

                                                                <SearchResults
                                                                    {...other}
                                                                    searchResults={state.searchResults}
                                                                    searchTotalCount={state.searchTotalCount}
                                                                    searchLimit={state.searchLimit}
                                                                    getNextResults={getNextResults}
                                                                    getAllResults={getAllResults}
                                                                    displaySearchResults={state.displaySearchResults}
                                                                    userDetails={userDetails}
                                                                    isFetching={state.isFetching}
                                                                    parentClasses={props.classes}
                                                                    selectedSearchConfig={state.selectedWorkspaceConfig.searchConfig}
                                                                    actionsConfig={actionsCfg}
                                                                    metadataConfig={configFiles.metadataConfig}
                                                                    optionsConfig={configFiles.optionsConfig}
                                                                    workspaceConfig={props.workspaceConfig}
                                                                    selectedWorkspaceConfig={state.selectedWorkspaceConfig}
                                                                    searchType={state.searchType}
                                                                    openFolder={openFolder}
                                                                    drawerOpen={drawerOpen}
                                                                    folderDetails={state.folderDetails}
                                                                    searchCriteria={state.searchCriteria}
                                                                    searchCriteriaSimple={state.searchCriteriaSimple}
                                                                    triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                                                                    nextMarker={state.nextMarker}
                                                                    templatesConfig={configFiles.templatesConfig}
                                                                    workflowConfig={configFiles.workflowConfig}
                                                                    reloadWorkspace={handleSelectWorkspace}
                                                                />
                                                            </InfiniteScroll>

                                                        </Grid>

                                                    </React.Fragment> :
                                                    <span/>
                                            }



                                        </Grid>

                                    }
                                </Grid>
                            </Grid>

                        </React.Fragment>
                    }

                    {(mode === 'admin' && state.showAdminGeneral) &&
                        <Admin parentClasses={props.classes} drawerOpen={drawerOpen}/>
                    }

                    {(mode === 'reporting' && state.mountDashboard) &&
                        <Dashboard parentClasses={props.classes}
                                   dashboardUrl={state.dashboardUrl}
                                   remountComponent={remountDashboard}
                        />
                    }

                    {(mode === 'forms') &&
                        <Form parentClasses={props.classes}/>
                    }

                    {(mode === 'tasks') &&
                        // <Form parentClasses={this.props.classes}/>
                        <AllTasks userDetails={userDetails}
                                  classes={props.classes}
                                  remountComponent={remountDashboard}
                                  triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                                  boxFolderID={state.folderDetails.boxFolderID}
                                  folderTasksConfig={actionsCfg.folderTasks}
                                  displayInOwnTab={true}

                        />
                    }
                    {state.showCompare &&
                        <ComparePreviousDialog
                            parentClasses={props.classes}
                            id={props.match.params.compareId}
                            handleCloseDialog={handleCloseCompareDialog}
                            userDetails={userDetails}
                            triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                            actionConfig={actionsCfg.comparePrevious}
                        />
                    }


                    {
                        state.showPreview &&
                        <PreviewDialog
                            boxDocID={props.match.params.id}
                            userDetails={userDetails}
                            handleCloseDialog={handleClosePreviewDialog}
                            parentClasses={props.classes}
                            calledFromDocumentMenu={false}
                            metadataConfig={configFiles.metadataConfig}
                            optionsConfig={configFiles.optionsConfig}
                            workspaceConfig={configFiles.workspaceConfig}
                            selectedWorkspaceConfig={state.selectedWorkspaceConfig}
                            actionsConfig={actionsCfg}
                            triggerRefreshAuthToken={props.triggerRefreshAuthToken}
                            documentMetadataFields={state.selectedWorkspaceConfig.searchConfig.documentSearch.documentMetadataFields}
                        />
                    }


                    {state.showMyDocuments &&
                        <MyDocumentsDialog
                            userDetails={userDetails}
                            handleMyDocumentsClose={handleMyDocumentsClose}
                            myDocumentsFolder={process.env.REACT_APP_MY_DOCUMENTS_FOLDER}
                        />
                    }

                </div>

            </React.Fragment>
        </LocalizationProvider>
    );

}

PortalApp.propTypes = {
    classes: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    userDetails: PropTypes.object.isRequired,
    workspaceConfig: PropTypes.array.isRequired,
    triggerRefreshAuthToken: PropTypes.func.isRequired,
    configFiles: PropTypes.object.isRequired,
    drawerWidth: PropTypes.number.isRequired,
    launchDashboard: PropTypes.bool.isRequired
};

export default withTranslation()((withStyles(styles, { withTheme: true })(PortalApp)));
